// src/pages/AdminDashboard.jsx
import React from "react";
import { useAdmin } from "../admin/AdminContext";
import AdminRooms from "../components/admin/AdminRooms";
import AdminUsers from "../components/admin/AdminUsers";
import AdminStats from "../components/admin/AdminStats";
import AdminLogs from "../components/admin/AdminLogs";

const AdminDashboard = () => {
  const { logout } = useAdmin();

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: 16,
        background: "radial-gradient(circle at top, #020617, #020617)",
        color: "#e5e7eb",
        fontFamily:
          "system-ui, -apple-system, BlinkMacSystemFont, 'SF Pro', sans-serif",
      }}
    >
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <div>
          <div style={{ fontSize: 20, fontWeight: 600 }}>
            Operate Live – Meet Admin
          </div>
          <div style={{ fontSize: 12, color: "#9ca3af" }}>
            Live rooms, users, and signaling events
          </div>
        </div>
        <button
          onClick={logout}
          style={{
            fontSize: 12,
            borderRadius: 999,
            border: "1px solid rgba(248,113,113,0.85)",
            padding: "6px 12px",
            background: "linear-gradient(135deg, #ef4444, #b91c1c)",
            color: "#f9fafb",
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </header>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "minmax(0, 2fr) minmax(0, 1.4fr)",
          gap: 16,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <AdminStats />
          <AdminRooms />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <AdminUsers />
          <AdminLogs />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
